import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import { useNavigate } from "react-router-dom";
import marketingImage from "../../images/marketing.jpg"; // Make sure image path is correct

const Marketing = () => {
  /* const navigate = useNavigate(); */

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Marketing</h1>

        <div className="cap-section">
          {/* Text Section */}
          <div className="text-content">
            <h2>Targeted Healthcare Marketing That Drives Patient Growth</h2>
            <p>
              Getting noticed in today’s competitive healthcare landscape requires more than just a website—it takes strategic digital marketing, SEO, and social media advertising tailored to the medical field.
              At S&S Healthcare Consulting, we help practices increase visibility, attract new patients, and build trust through targeted marketing campaigns.
            </p>
            <p>
              From creating engaging ads and optimizing your online presence to managing multi-platform campaigns across Facebook, Instagram, Google, and more—we make sure your services reach the right audience at the right time.
              Our approach turns clicks into appointments and impressions into real results—bringing more patients through your doors and helping your practice grow.
            </p>

          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={marketingImage} alt="Medical Billing" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Marketing;
